import { Sender } from 'xstate';

import config from '../../../config';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { fetchLiveTables } from '../../../model/liveTable';
import { isEqual } from '../../../utils/lodash-alternatives';

import { LogicContext } from '../types';

export const watchLiveTableGames = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'LIVE_TABLE_GAMES_UPDATED';
        data: { liveDealerTables: LogicContext['currentTables'] };
      }>
    ) => {
      let intervalToken: ReturnType<typeof setInterval>;

      const { currentTablesIdList } = context;
      if (!currentTablesIdList || !currentTablesIdList.length) {
        return () => {};
      }

      if (
        currentTablesIdList.length > 0 &&
        config.intervals.liveTableGamesCheck
      ) {
        intervalToken = setInterval(async () => {
          const tables = await fetchLiveTables(
            currentTablesIdList,
            context.user?.currency || config.default_currency
          );

          if (!isEqual(context.currentTables, tables)) {
            callback({
              type: 'LIVE_TABLE_GAMES_UPDATED',
              data: {
                liveDealerTables: tables,
              },
            });
          }
        }, config.intervals.liveTableGamesCheck);
      }

      return () => {
        if (intervalToken) {
          clearInterval(intervalToken);
        }
      };
    }
  );
